import * as React from 'react';
import AntForm, {
    FormItemProps as AntFormItemProps,
    FormProps as AntFormProps,
    FormInstance as AntFormInstance,
} from 'antd/lib/form';
import './AntdGridStyle.less';
import './FormItem.less';
import Styles from './FormItem.module.less';
import { classes, formRules, option, fromOptionToNullable } from '../../lib';

export type FormItemProps = AntFormItemProps & {
    description?: React.ReactNode;
    justifyInput?: boolean;
    requiredMessage?: string;
};

export type FormProps = AntFormProps;
// eslint-disable-next-line
export type FormInstance<T = any> = AntFormInstance<T>;

const FormBase = <Values,>(
    props: FormProps,
    ref: React.Ref<FormInstance<Values>> | undefined
): JSX.Element => {
    return <AntForm ref={ref} {...props} prefixCls={Styles.form} />;
};

export const Form = React.forwardRef(FormBase);

export const FormItem = ({
    description,
    label,
    justifyInput,
    className,
    requiredMessage,
    rules = [],
    ...props
}: FormItemProps): JSX.Element => {
    const labelWrapper =
        !label && !description ? null : (
            <>
                {label}
                {fromOptionToNullable(
                    option.map(
                        description => (
                            <span
                                key={0}
                                className="alude-form-item-label-description">
                                {description}
                            </span>
                        ),
                        description
                    )
                )}
            </>
        );
    const rulesToUse = props.required
        ? [formRules.required(requiredMessage), ...rules]
        : rules;
    return (
        <AntForm.Item
            label={labelWrapper}
            rules={rulesToUse}
            className={classes(className, justifyInput && Styles.justifyInput)}
            {...props}
            prefixCls={Styles.form}
        />
    );
};

export const useForm = AntForm.useForm;
